import React, { useState } from "react";
import FieldForInput from "../../component/input_field/FieldForInput.js";
import {
    Typography,
} from "@mui/material";
import Button from "../../component/button/Button";
import { useFormik } from "formik";
import BubbleLoader from "../../component/Loader/BubbleLoader.js";
import emailjs from "@emailjs/browser";
import AlternateAuthLayout from "../../layout/AlternateAuthLayout.js";
import { contactSchema } from "../../schemas/index.js"
import { toast } from "react-hot-toast";

const ContactUs = () => {
    const [loading, setLoading] = useState(false);
    const initialValues = { name: "", email: "", message: "" }

    const {
        values,
        errors,
        handleBlur,
        handleChange,
        touched,
        handleSubmit,
    } = useFormik({
        initialValues: initialValues,
        validationSchema: contactSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                const response = await emailjs.send(
                    process.env.REACT_APP_SERVICE_ID,
                    process.env.REACT_APP_TEMPLATE_ID,
                    {
                        from_name: values.name,
                        reply_to: values.email,
                        message: values.message,
                        to_name: "REPP Team",
                    },
                    process.env.REACT_APP_PUBLIC_KEY
                );

                console.log("Email sent successfully:", response);
                toast.success("Email sent successfully!")

                // Reset the form after successful submission
                resetForm();
            } catch (error) {
                console.error("Failed to send email:", error);
                toast.error("Failed to send email. Please try again.")
            } finally {
                setLoading(false);
            }
        }
    });




    return (
        <AlternateAuthLayout>
            <form className="admin-login-content" onSubmit={handleSubmit}>
                <div className="admin-login-div">
                    <h2 className="admin-login-text">Contact Us</h2>
                </div>
                <div>   
                <label className="login-input-label">Full Name</label>
                    <FieldForInput
                        className="login-field"
                        name="name"
                        placeholder="Enter full name"
                        width="572px"
                        height="60px"
                        borderRadius="100px"
                        marginTop="10px"
                        marginBottom="20px"
                        border=" 1px solid rgba(225, 225, 225, 1)"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        maxLength={50}
                        value={values.name}
                    />
                    {errors.name && touched.name ? (
                        <p style={{ color: "red", marginTop: "-20px", marginLeft: "20px" }}>
                            {errors.name}
                        </p>
                    ) : null}
                    </div>
                <div> <label className="login-input-label">Email Address</label>
                    <FieldForInput
                        className="login-field"
                        name="email"
                        placeholder="Enter email address"
                        width="572px"
                        height="60px"
                        borderRadius="100px"
                        marginTop="10px"
                        marginBottom="20px"
                        border=" 1px solid rgba(225, 225, 225, 1)"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.email}
                    />
                    {errors.email && touched.email ? (
                        <p style={{ color: "red", marginTop: "-20px", marginLeft: "20px" }}>
                            {errors.email}
                        </p>
                    ) : null}</div>

                <div> <label className="login-input-label">Message</label>
                    <FieldForInput
                        // className="login-field"
                        name="message"
                        width="572px"
                        height="60px"
                               placeholder="Enter message"
                        borderRadius="100px"
                        marginTop="10px"
                        marginBottom="20px"
                        border=" 1px solid rgba(225, 225, 225, 1)"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        maxLength={450}
                        value={values.message}
                    />
                    {errors.message && touched.message ? (
                        <p style={{ color: "red", marginTop: "-20px", marginLeft: "20px" }}>
                            {errors.message}
                        </p>
                    ) : null}</div>

              

                <div className="login-button-div">
                    <Button
                        backgroundColor="rgba(0, 176, 80, 1)"
                        color="white"
                        width="572px"
                        height="60px"
                        borderRadius="100px"
                        border="none"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? <BubbleLoader color="#FFF" size="1rem" /> : "SUBMIT"}
                    </Button>
                </div>

            </form>
        </AlternateAuthLayout>
    );
};

export default ContactUs;
